import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { DENY_JOIN_REQUEST_RESOURCE, JOIN_REQUESTS_RESOURCE } from '../../constants';

const DenyJoinRequestService = ComposedComponent =>
  reduxFetch([
    {
      resource: DENY_JOIN_REQUEST_RESOURCE,
      method: 'delete',
      request: (id, callback, rejectCallback, t) => ({
        url: apiRoutes.denyJoinRequests(id),
        meta: {
          removeFromOtherList: {
            resource: JOIN_REQUESTS_RESOURCE,
            idProp: 'id',
            id,
          },
          callback,
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'denyJoinRequestFailed'),
            onSuccessMessage: t('denyJoinRequestSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default DenyJoinRequestService;
